import Icon from '@/asset/Icon'
import Button from 'react-bootstrap/esm/Button'

export default function YoutubeUIPlugin() {
  return (
    <Button variant="outline-secondary">
      <Icon type="youtube" />
    </Button>
  )
}
